import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { openExternalUrl, type FilePreviewState } from './fileOpen';

export function FilePreviewModal({
  preview,
  onClose
}: {
  preview: FilePreviewState;
  onClose: () => void;
}) {
  const [frameError, setFrameError] = useState(false);

  useEffect(() => {
    setFrameError(false);
  }, [preview.url]);

  useEffect(() => {
    const url = preview.url;
    return () => {
      if (url.startsWith('blob:')) {
        try {
          URL.revokeObjectURL(url);
        } catch {
          /* ignore */
        }
      }
    };
  }, [preview.url]);

  if (typeof document === 'undefined') return null;

  const kind = preview.kind;

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Превью файла"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10050,
        background: 'rgba(0,0,0,0.92)',
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 10px calc(12px + env(safe-area-inset-bottom, 0px))',
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 10,
          flexShrink: 0
        }}
      >
        <button type="button" className="fc-back" aria-label="Закрыть" onClick={onClose}>
          ←
        </button>
        <p
          style={{
            margin: 0,
            flex: 1,
            minWidth: 0,
            fontSize: 14,
            fontWeight: 650,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {preview.name}
        </p>
        <button type="button" className="fc-btn fc-btn--dark fc-btn--sm" onClick={onClose}>
          ✕
        </button>
      </div>

      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          borderRadius: 8,
          background: kind === 'image' ? 'transparent' : '#111'
        }}
      >
        {kind === 'image' ? (
          <img
            src={preview.url}
            alt={preview.name}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              borderRadius: 8
            }}
          />
        ) : frameError ? (
          <p style={{ margin: 16, textAlign: 'center', color: '#b8c4ce', fontSize: 14, lineHeight: 1.45 }}>
            Не удалось показать превью в приложении. Скачайте файл кнопкой ниже.
          </p>
        ) : (
          <iframe
            title={preview.name}
            src={preview.url}
            onError={() => setFrameError(true)}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: 8,
              background: '#fff'
            }}
            allow="fullscreen"
          />
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 12, flexShrink: 0 }}>
        <button
          type="button"
          className="fc-btn fc-btn--primary"
          style={{ flex: 1 }}
          onClick={() => openExternalUrl(preview.downloadUrl)}
        >
          Скачать / открыть снаружи
        </button>
        <button type="button" className="fc-btn fc-btn--dark" style={{ flex: 1 }} onClick={onClose}>
          Закрыть
        </button>
      </div>
    </div>,
    document.body
  );
}
